export class AddonTotalExceedsCourtroomLimitError extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, AddonTotalExceedsCourtroomLimitError.prototype)
  }
}
